export const normalizeAssemblySteps = (result) => {
  const piano = Array.isArray(result?.assembly_plan) ? result.assembly_plan : []
  if (piano.length > 0) return piano

  const mancanze = Array.isArray(result?.mancanze) ? result.mancanze : []
  return mancanze
    .filter((m) => m?.tipologia_box_id)
    .map((m, idx) => ({
      step: idx + 1,
      tipologia_box_id: m.tipologia_box_id,
      tipologia_box_nome: m.tipologia_box_nome || `Box #${m.tipologia_box_id}`,
      da_assemblare: m.mancanti || 0,
      richieste_totali: m.da_spedire || 0,
      assemblate_disponibili: m.assemblate_disponibili || 0,
    }))
}

export const buildAssemblyUrl = ({ step, ordineNumero, returnTo }) => {
  const params = new URLSearchParams({
    tipologia_box: String(step.tipologia_box_id),
    ordine_numero: ordineNumero || '',
  })

  const quantita = Number.parseInt(step.da_assemblare, 10)
  if (Number.isFinite(quantita) && quantita > 0) {
    params.set('quantita', String(quantita))
  }

  if (returnTo) {
    params.set('return_to', returnTo)
  }

  return `/box/tipologie/assembla?${params.toString()}`
}
